// Generated from SVG to Code Figma Plugin

import type { JSX } from 'react';

export const FreeGenerateIcon = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7 12.5H41C42.933 12.5 44.5 14.067 44.5 16V32C44.5 33.933 42.933 35.5 41 35.5H7C5.067 35.5 3.5 33.933 3.5 32V16C3.5 14.067 5.067 12.5 7 12.5Z"
      fill="url(#paint0_linear_29273_5944)"
      stroke="url(#paint1_linear_29273_5944)"
    />
    <path
      d="M9.06232 29V19.13H15.7543V21.314H11.8063V23.05H14.7183V25.136H11.8063V29H9.06232ZM22.132 22.448C22.132 21.832 21.754 21.426 21.012 21.426H19.654V23.484H21.012C21.754 23.484 22.132 23.12 22.132 22.448ZM16.91 19.13H21.236C23.686 19.13 24.918 20.53 24.918 22.294C24.918 23.582 24.218 24.702 22.748 25.15L24.974 29H21.908L19.948 25.36H19.654V29H16.91V19.13ZM32.4798 19.13V21.328H28.9098V22.938H32.0598V25.024H28.9098V26.802H32.4798V29H26.1658V19.13H32.4798ZM40.1498 19.13V21.328H36.5798V22.938H39.7298V25.024H36.5798V26.802H40.1498V29H33.8358V19.13H40.1498Z"
      fill="currentColor"
    />
    <defs>
      <linearGradient id="paint0_linear_29273_5944" gradientUnits="userSpaceOnUse" x1="24" x2="24" y1="36" y2="12">
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#737373" />
      </linearGradient>
      <linearGradient id="paint1_linear_29273_5944" gradientUnits="userSpaceOnUse" x1="24" x2="24" y1="36" y2="12">
        <stop stopColor="currentColor" />
        <stop offset="1" stopColor="#999999" />
      </linearGradient>
    </defs>
  </svg>
);
